export class ControlComplianceEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "controlId",
            "baseName": "controlId",
            "type": "string",
            "format": ""
        },
        {
            "name": "controlName",
            "baseName": "controlName",
            "type": "string",
            "format": ""
        },
        {
            "name": "applicableResources",
            "baseName": "applicableResources",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "failingResources",
            "baseName": "failingResources",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "groupBreakdowns",
            "baseName": "groupBreakdowns",
            "type": "Array<GroupBreakdown>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ControlComplianceEntry.attributeTypeMap;
    }
    constructor() {
    }
}
